import {useEffect} from "react";

export const useOutsideClickDetector = (ref, action, ignoredIds) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target) && !ignoredIds.includes(event.target.id)) {
                action();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
};